import {MI} from "../init";
import LinesInfo from "./LinesInfo";

/**
 * @constructor
 * @returns {undefined}
 */
export default function GameHeader() {

    /** @type {MadnesObject} */
    this._logo;

    this._logoHidePos = -116;

    /** @type {MadnesObject} */
    this._clock;

    /** @type {number} */
    this._clockInitPos = -156;
    /** @type {number} */
    this._clockPos = -8;

    /** @type {MadnesObject} */
    this._clockText;

    /** @type {LinesInfo} */
    this.lines;

    this._type = "logo";
}

GameHeader.prototype.getType = function() {
    return this._type;
};

GameHeader.prototype.create = function() {
    this._logo = MI.addImg(MI.getWi() / 2, 0, "reels_atlas").setFrameName("logo").setAnchor(0.5, 0);

    this._clock = MI.addImg(MI.getWi() / 2, this._clockInitPos, "boomspins_atlas").setFrameName("background_boom-spins_clock");
    this._clock.setAnchor(0.5, 0);
    this._clock.setVisible(false);

    this._clockText = MI.addBitmapText("font_freespins", 0, 80, "", 38);
    this._clockText.setAnchor(0.5, 0.5);
    this._clock.addChild(this._clockText);

    this.lines = new LinesInfo();
    this.lines.create();
};

GameHeader.prototype.set = function(type) {
    switch(type) {
        case "logo":
            this.lines.hide();
            this._hideClock();
            this._showLogo();

            this._type = "logo";
            break;

        case "lines":
            this._hideLogo();
            this._hideClock();
            this.lines.show();

            this._type = "lines";
            break;

        case "bonus":
            this.lines.hide();
            this._hideLogo();

            this._showClock();

            this._type = "bonus";
            break;
    }
};

GameHeader.prototype.show = function(type) {
    var _self = this;
    var anims = [];

    switch(type) {
        case "logo":

            anims.push(this.lines.animHide());
            anims.push(this._hideClockAnim());

            return Promise.all(anims).then(function() {
                _self._type = "logo";
                return _self._showLogoAnim();
            });

            break;

        case "lines":

            anims.push(this._hideLogoAnim());
            anims.push(this._hideClockAnim());

            return Promise.all(anims).then(function() {
                _self._type = "lines";
                return _self.lines.animShow();
            });

            break;

        case "bonus":

            anims.push(this._hideLogoAnim());
            anims.push(this.lines.animHide());

            return Promise.all(anims).then(function() {
                _self._type = "bonus";

                return _self._showClockAnim();
            });

            break;

        default:
            return new Promise(function(res) { res(); });
            break;
    }
};

GameHeader.prototype._showLogo = function () {
    this._logo.setPosY(0);
    this._logo.setVisible(true);
};

GameHeader.prototype._showLogoAnim = function() {
    var _self = this;

    return new Promise(function(res) {

        _self._logo.setVisible(true);

        //console.log("_showLogoAnim", _self._logo.getPosY());

//		setTimeout(function() {
//			console.log(_self._logo.getPosY());
//			debugger;
//		}, 1);

        if(_self._logo.getPosY() === 0) {
            res();
            return;
        }

        MI.addTween().to(_self._logo, { 'y': 0 }, {
            'duration': 200,
            'callback': res
        });
    });
};

GameHeader.prototype._hideLogo = function() {
    this._logo.setPosY(this._logoHidePos);
    this._logo.setVisible(false);
};

GameHeader.prototype._hideLogoAnim = function() {
    var _self = this;

    return new Promise(function(res) {

        if(_self._logo.getPosY() === _self._logoHidePos) {
            res();
            return;
        }

        MI.addTween().to(_self._logo, { 'y': _self._logoHidePos }, {
            'duration': 200,
            'callback': function() {

//				console.log(_self._logo.getPosY());
//				debugger;

                _self._logo.setVisible(false);
                res();
            }
        });
    });
};

GameHeader.prototype._showClock = function() {
    this._clock.setPosY(this._clockPos);
    this._clock.setVisible(true);
};

GameHeader.prototype._showClockAnim = function() {
    var _self = this;

    return new Promise(function(res) {

        _self._clock.setVisible(true);

        if(_self._clock.getPosY() === _self._clockPos) {
            res();
            return;
        }

        MI.addTween().to(_self._clock, { 'y': _self._clockPos }, {
            'duration': 200,
            'callback': res
        });
    });
};

GameHeader.prototype._hideClock = function() {
    this._clock.setPosY(this._clockInitPos);
    this._clock.setVisible(false);
};

GameHeader.prototype._hideClockAnim = function() {
    var _self = this;

    return new Promise(function(res) {

        if(_self._clock.getPosY() === _self._clockInitPos) {
            res();
            return;
        }

        MI.addTween().to(_self._clock, { 'y': _self._clockInitPos }, {
            'duration': 200,
            'callback': function() {
                _self._clock.setVisible(false);
                res();
            }
        });
    });
};

GameHeader.prototype.setBoomSpinsCount = function(count) {
    this._clockText.setText(count);
};